module.exports = __webpack_public_path__ + "img/news01.0c75860c.jpeg";